module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"last_updated":"Последнее изменение {0}","What\u0027s new?":"Что нового?"},"en":{"last_updated":"Last updated {0}"}}')
  delete Component.options._Ctor
}
